<template>
  <div class="pb-3" >
    <va-card :title="$t(`partners.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="partner.name"
                  :label="$t('partners.forms.nameLabel')"
                  :placeholder="$t('partners.forms.namePlaceholder')"
                  :success="errors.length == 0 && partner.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required|max:20" name="Código" v-slot="{ errors }">
                <va-input
                  v-model="partner.code"
                  :label="$t('partners.forms.codeLabel')"
                  :placeholder="$t('partners.forms.codePlaceholder')"
                  :success="errors.length == 0 && partner.code.length > 0 && partner.code.length <= 20"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="numeric" name="Usuário" v-slot="{ errors }">
                <va-input
                  v-model="user"
                  :label="$t('partners.forms.userLabel')"
                  :placeholder="$t('partners.forms.userPlaceholder')"
                  :success="errors.length == 0 && user >= 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="numeric" name="Cliente" v-slot="{ errors }">
                <va-input
                  v-model="client"
                  :label="$t('partners.forms.clientLabel')"
                  :placeholder="$t('partners.forms.clientPlaceholder')"
                  :success="errors.length == 0 && client >= 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <va-toggle
                v-model="partner.active"
                small
                :label="$t('partners.forms.activePlaceholder')"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'PartnersAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      partner: {
        name: '',
        code: '',
        user_id: '',
        client_id: '',
        active: true,
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  computed: {
    user: {
      get () {
        return this.partner.user_id
      },
      set (value) {
        if (value >= 0) {
          this.partner.user_id = value
        }
      },
    },
    client: {
      get () {
        return this.partner.client_id
      },
      set (value) {
        if (value >= 0) {
          this.partner.client_id = value
        }
      },
    },
  },
  created () {
    this.partner.name = ''
    this.partner.code = ''
    this.partner.active = true
    this.partner.user_id = 0
    this.partner.client_id = 0
    if (this.updateData !== null) {
      this.partner_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.partner_get(this.updateData)
      } else {
        this.partner.name = ''
        this.partner.code = ''
        this.partner.active = true
        this.partner.user_id = 0
        this.partner.client_id = 0
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    partner_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value === 'client' || value === 'user') {
          this.partner[value + '_id'] = data[value] !== null ? data[value].id : 0
        } else if (value !== '__typename') {
          this.partner[value] = data[value]
        }
      })
    },
    onSubmit () {
      const { name, code, active } = this.partner
      const clientId = this.partner.client_id !== 0 ? this.partner.client_id : null
      const userId = this.partner.user_id !== 0 ? this.partner.user_id : null
      if (clientId !== '' || userId !== '') {
        this.buttonSubmitDisabled = true
        this.textSubmit = this.$t('forms.submitting')
        const self = this
        this.$apollo
          .mutate({
            mutation: (
              this.updateData !== null ? gql`
                  mutation MyMutation($name: String!, $code: String!, $active: Boolean, $user_id: Int, $client_id: Int, $id: Int!) {
                    update_partner_by_pk(pk_columns: {id: $id}, _set: {name: $name, code: $code, active: $active, user_id: $user_id, client_id: $client_id}) {
                      id
                    }
                  }
                  ` : gql`
                  mutation MyMutation($name: String, $code: String, $active: Boolean, $user_id: Int, $client_id: Int) {
                    insert_partner(objects: {name: $name, code: $code, active: $active, user_id: $user_id, client_id: $client_id}) {
                      affected_rows
                    }
                  }
                  `),
            variables: this.updateData !== null ? {
              name,
              code,
              active,
              client_id: clientId,
              user_id: userId,
              id: this.partner.id,
            } : {
              name,
              code,
              active,
              client_id: clientId,
              user_id: userId,
            }
            ,
          })
          .then(data => {
            self.buttonSubmitDisabled = false
            self.textSubmit = self.$t('forms.submit')
            self.partner.name = ''
            self.partner.code = ''
            self.partner.active = true
            self.partner.user_id = 0
            self.partner.client_id = 0
            self.$emit('showAdd', false)
            self.$emit('showMore', self.page)
            self.showToast(
              self.$t(
                self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
              ),
              {
                icon: 'fa-check',
                position: 'top-right',
                duration: 1000,
                fullWidth: false,
              },
            )
          })
          .catch(_ => {
            self.buttonSubmitDisabled = false
            self.textSubmit = self.$t('forms.submit')
            self.showToast(
              self.$t(
                self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
              ),
              {
                icon: 'fa-check',
                position: 'top-right',
                duration: 1000,
                fullWidth: false,
              },
            )
          })
      } else {
        this.showToast(
          this.$t(
            'partners.toasts.error',
          ),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      }
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
